import { Component } from '@angular/core';

@Component({
    selector: 'app-redirect',
    template: ''
})
export class RedirectComponent {}
